import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './BusinessWorker.module.css';
import BusinessWorkerBoy from '../../assets/worker-banner-new.png';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';

function BusinessWorker(props) {
  const { history, isAuthenticated } = props;
  const buttonWorker = !isAuthenticated ? (
    <>
      <button
        className={css.BusinessWorkerDescbtn}
        onClick={e => {
          e.stopPropagation();
          history.push(createResourceLocatorString('SignupPage', routeConfiguration(), {}, {}));
        }}
      >
        <FormattedMessage id="BusinessWorker.DescButton" />
      </button>
    </>
  ) : null;
  return (
    <>
      <div className={css.BusinessWorkerMain}>
        <img className={css.BusinessWorkerImg} src={BusinessWorkerBoy} alt="" />
        <div className={css.BusinessWorkWrap}>
          <div className={css.BusinessWorkerDesc}>
            <p className={css.p1}>
              <FormattedMessage id="BusinessWorker.DescFirst" />{' '}
              <span className={css.span1}>
                {/* <FormattedMessage id="BusinessWorker.DescSpan1" /> */}
              </span>
              <span>{/* <FormattedMessage id="BusinessWorker.DescAnd" /> */}</span>
              <span className={css.span1}>
                {/* <FormattedMessage id="BusinessWorker.DescEmployer" /> */}
              </span>
              {/* <FormattedMessage id="BusinessWorker.DescFirst1" />{' '} */}
            </p>
            <p className={css.p2}>
              <FormattedMessage id="BusinessWorker.DescSecond" />
            </p>

            {buttonWorker}
          </div>
        </div>
      </div>

      {/* <div className={css.BusinessWorkerImgSection}></div> */}
    </>
  );
}

export default compose(withRouter)(BusinessWorker);
